import A11yDialog from '../../../../node_modules/a11y-dialog/dist/a11y-dialog'
import { googleAnalyticsLoadModal } from '../../../js/datalayer'

require('./_modal-popup.scss')
require('../../../../node_modules/a11y-dialog/dist/a11y-dialog')


class ModalPopup {
    constructor(element) {
        const html = document.documentElement
        this.element = element
        this.instanceA11 = new A11yDialog(element)

        this.instanceA11.on('show', (modal, event) => {
            // After modal opens
            googleAnalyticsLoadModal(modal.id)
            html.style.overflowY = 'hidden'
        })

        this.instanceA11.on('hide', (modal) => {
            const form = this.element.querySelector('form')
            if (form) {
                //reset form values
                form.reset()
                if (form.formValidator && form.formValidator.resetValidationErrors) {
                    //reset form feedback errors
                    form.formValidator.resetValidationErrors()
                }
            }
            html.style.overflowY = ''
        })
    }
}

export default ModalPopup
